import React, {useCallback, useState} from "react";
import api from "../../api/facilities";

const initialData = {
  facilities: [],
  createdFacility: null,
  deletedFacility: null
};

export default function useBuildings() {
  const [data, setBuildingsData_] = React.useState(initialData);

  const [isCreatingFacility, setIsCreatingFacility] = useState(false);
  const [isDeletingFacilities, setIsDeletingFacilities] = useState(false);

  const setBuildingsData = newData => {
    const newBuildingsData = {
      ...data,
      ...newData
    };

    setBuildingsData_(newBuildingsData);
  };

  const deleteFacilities = useCallback((idList) => {
    setIsDeletingFacilities(true);
    return Promise.all(idList.map(api.deleteFacility))
      .then(response => {
        setIsDeletingFacilities(false);
        setBuildingsData({deletedFacility: response});
      }, () => {
        setIsDeletingFacilities(false);
      });
  }, [setIsDeletingFacilities]);

  const createFacility = useCallback((data) => {
    setIsCreatingFacility(true);
    return api.createFacility(data)
      .then(({ data }) => {
        setIsCreatingFacility(false);
        setBuildingsData({createdFacility: data});
      }, () => {
        setIsCreatingFacility(false);
      });
  }, [setIsCreatingFacility]);

  return {
    data,
    createFacility,
    isCreatingFacility,
    deleteFacilities,
    isDeletingFacilities
  };
}
